export const phxWebStyleTokens = {
  "colorBackground": "var(--phx-web-color-background)",
  "colorBackgroundPrimary": "var(--phx-web-color-background-primary)",
  "colorBackgroundSecondary": "var(--phx-web-color-background-secondary)",
  "colorBackgroundTertiary": "var(--phx-web-color-background-tertiary)",
  "colorBackgroundHover": "var(--phx-web-color-background-hover)",
  "colorBackgroundPressed": "var(--phx-web-color-background-pressed)",
  "colorBackgroundInactive": "var(--phx-web-color-background-inactive)",
  "colorBackgroundActive": "var(--phx-web-color-background-active)",
  "colorBackgroundNeutral": "var(--phx-web-color-background-neutral)",
  "colorBackgroundAccent": "var(--phx-web-color-background-accent)",
  "colorBackgroundPositive": "var(--phx-web-color-background-positive)",
  "colorBackgroundCaution": "var(--phx-web-color-background-caution)",
  "colorBackgroundWarning": "var(--phx-web-color-background-warning)",
  "colorBackgroundNegative": "var(--phx-web-color-background-negative)",
  "colorBackgroundSummary": "var(--phx-web-color-background-summary)",
  "colorBackgroundInverted": "var(--phx-web-color-background-inverted)",
  "colorBackgroundAlwaysLight": "var(--phx-web-color-background-always-light)",
  "colorBackgroundAlwaysDark": "var(--phx-web-color-background-always-dark)",
  "colorBackgroundOverlay": "var(--phx-web-color-background-overlay)",
  "colorBackgroundShade": "var(--phx-web-color-background-shade)",
  "colorBackgroundTransparent": "var(--phx-web-color-background-transparent)",
  "colorBackgroundProfile": "var(--phx-web-color-background-profile)",
  "colorBackgroundMediumNeutral": "var(--phx-web-color-background-medium-neutral)",
  "colorBackgroundMediumCaution": "var(--phx-web-color-background-medium-caution)",
  "colorBackgroundMediumWarning": "var(--phx-web-color-background-medium-warning)",
  "colorBackgroundOnMediumHover": "var(--phx-web-color-background-on-medium-hover)",
  "colorBackgroundOnMediumPressed": "var(--phx-web-color-background-on-medium-pressed)",
  "colorBackgroundOnMediumInactive": "var(--phx-web-color-background-on-medium-inactive)",
  "colorBackgroundOnMediumActive": "var(--phx-web-color-background-on-medium-active)",
  "colorBackgroundBoldNeutral": "var(--phx-web-color-background-bold-neutral)",
  "colorBackgroundBoldActive": "var(--phx-web-color-background-bold-active)",
  "colorBackgroundBoldAccent": "var(--phx-web-color-background-bold-accent)",
  "colorBackgroundBoldPositive": "var(--phx-web-color-background-bold-positive)",
  "colorBackgroundBoldNegative": "var(--phx-web-color-background-bold-negative)",
  "colorBackgroundOnBoldHover": "var(--phx-web-color-background-on-bold-hover)",
  "colorBackgroundOnBoldPressed": "var(--phx-web-color-background-on-bold-pressed)",
  "colorBackgroundOnBoldInactive": "var(--phx-web-color-background-on-bold-inactive)",
  "colorBackgroundOnBoldActive": "var(--phx-web-color-background-on-bold-active)",
  "colorBackgroundOnSummaryHover": "var(--phx-web-color-background-on-summary-hover)",
  "colorBackgroundOnSummaryPressed": "var(--phx-web-color-background-on-summary-pressed)",
  "colorBackgroundOnSummaryInactive": "var(--phx-web-color-background-on-summary-inactive)",
  "colorBackgroundOnSummaryActive": "var(--phx-web-color-background-on-summary-active)",
  "colorBackgroundOnInvertedHover": "var(--phx-web-color-background-on-inverted-hover)",
  "colorBackgroundOnInvertedPressed": "var(--phx-web-color-background-on-inverted-pressed)",
  "colorBackgroundOnInvertedInactive": "var(--phx-web-color-background-on-inverted-inactive)",
  "colorBackgroundOnInvertedActive": "var(--phx-web-color-background-on-inverted-active)",
  "colorBackgroundOnOverlayHover": "var(--phx-web-color-background-on-overlay-hover)",
  "colorBackgroundOnOverlayPressed": "var(--phx-web-color-background-on-overlay-pressed)",
  "colorBackgroundOnOverlayInactive": "var(--phx-web-color-background-on-overlay-inactive)",
  "colorBackgroundOnOverlayActive": "var(--phx-web-color-background-on-overlay-active)",
  "colorBackgroundOnAlwaysDarkHover": "var(--phx-web-color-background-on-always-dark-hover)",
  "colorBackgroundOnAlwaysDarkPressed": "var(--phx-web-color-background-on-always-dark-pressed)",
  "colorBackgroundOnAlwaysDarkInactive": "var(--phx-web-color-background-on-always-dark-inactive)",
  "colorBackgroundOnAlwaysDarkActive": "var(--phx-web-color-background-on-always-dark-active)",
  "colorContent": "var(--phx-web-color-content)",
  "colorContentStandard": "var(--phx-web-color-content-standard)",
  "colorContentEmphasis": "var(--phx-web-color-content-emphasis)",
  "colorContentSubdued": "var(--phx-web-color-content-subdued)",
  "colorContentInactive": "var(--phx-web-color-content-inactive)",
  "colorContentActive": "var(--phx-web-color-content-active)",
  "colorContentAccent": "var(--phx-web-color-content-accent)",
  "colorContentPositive": "var(--phx-web-color-content-positive)",
  "colorContentCaution": "var(--phx-web-color-content-caution)",
  "colorContentWarning": "var(--phx-web-color-content-warning)",
  "colorContentNegative": "var(--phx-web-color-content-negative)",
  "colorContentFaded": "var(--phx-web-color-content-faded)",
  "colorContentOnMedium": "var(--phx-web-color-content-on-medium)",
  "colorContentOnMediumEmphasis": "var(--phx-web-color-content-on-medium-emphasis)",
  "colorContentOnMediumInactive": "var(--phx-web-color-content-on-medium-inactive)",
  "colorContentOnBold": "var(--phx-web-color-content-on-bold)",
  "colorContentOnBoldEmphasis": "var(--phx-web-color-content-on-bold-emphasis)",
  "colorContentOnBoldInactive": "var(--phx-web-color-content-on-bold-inactive)",
  "colorContentOnSummary": "var(--phx-web-color-content-on-summary)",
  "colorContentOnSummaryStandard": "var(--phx-web-color-content-on-summary-standard)",
  "colorContentOnSummaryEmphasis": "var(--phx-web-color-content-on-summary-emphasis)",
  "colorContentOnSummarySubdued": "var(--phx-web-color-content-on-summary-subdued)",
  "colorContentOnSummaryInactive": "var(--phx-web-color-content-on-summary-inactive)",
  "colorContentOnSummaryAccent": "var(--phx-web-color-content-on-summary-accent)",
  "colorContentOnSummaryPositive": "var(--phx-web-color-content-on-summary-positive)",
  "colorContentOnSummaryCaution": "var(--phx-web-color-content-on-summary-caution)",
  "colorContentOnSummaryWarning": "var(--phx-web-color-content-on-summary-warning)",
  "colorContentOnSummaryNegative": "var(--phx-web-color-content-on-summary-negative)",
  "colorContentOnInverted": "var(--phx-web-color-content-on-inverted)",
  "colorContentOnInvertedStandard": "var(--phx-web-color-content-on-inverted-standard)",
  "colorContentOnInvertedEmphasis": "var(--phx-web-color-content-on-inverted-emphasis)",
  "colorContentOnInvertedSubdued": "var(--phx-web-color-content-on-inverted-subdued)",
  "colorContentOnInvertedInactive": "var(--phx-web-color-content-on-inverted-inactive)",
  "colorContentOnInvertedActive": "var(--phx-web-color-content-on-inverted-active)",
  "colorContentOnInvertedAccent": "var(--phx-web-color-content-on-inverted-accent)",
  "colorContentOnInvertedPositive": "var(--phx-web-color-content-on-inverted-positive)",
  "colorContentOnInvertedCaution": "var(--phx-web-color-content-on-inverted-caution)",
  "colorContentOnInvertedWarning": "var(--phx-web-color-content-on-inverted-warning)",
  "colorContentOnInvertedNegative": "var(--phx-web-color-content-on-inverted-negative)",
  "colorContentOnOverlay": "var(--phx-web-color-content-on-overlay)",
  "colorContentOnOverlayStandard": "var(--phx-web-color-content-on-overlay-standard)",
  "colorContentOnOverlaySubdued": "var(--phx-web-color-content-on-overlay-subdued)",
  "colorContentOnOverlayInactive": "var(--phx-web-color-content-on-overlay-inactive)",
  "colorContentOnAlwaysDark": "var(--phx-web-color-content-on-always-dark)",
  "colorContentOnAlwaysDarkStandard": "var(--phx-web-color-content-on-always-dark-standard)",
  "colorContentOnAlwaysDarkEmphasis": "var(--phx-web-color-content-on-always-dark-emphasis)",
  "colorContentOnAlwaysDarkSubdued": "var(--phx-web-color-content-on-always-dark-subdued)",
  "colorContentOnAlwaysDarkInactive": "var(--phx-web-color-content-on-always-dark-inactive)",
  "colorContentOnAlwaysDarkActive": "var(--phx-web-color-content-on-always-dark-active)",
  "colorContentOnAlwaysDarkAccent": "var(--phx-web-color-content-on-always-dark-accent)",
  "colorContentOnAlwaysDarkPositive": "var(--phx-web-color-content-on-always-dark-positive)",
  "colorContentOnAlwaysDarkCaution": "var(--phx-web-color-content-on-always-dark-caution)",
  "colorContentOnAlwaysDarkWarning": "var(--phx-web-color-content-on-always-dark-warning)",
  "colorContentOnAlwaysDarkNegative": "var(--phx-web-color-content-on-always-dark-negative)",
  "colorDataCatagorical-1": "var(--phx-web-color-data-catagorical-1)",
  "colorDataCatagorical-2": "var(--phx-web-color-data-catagorical-2)",
  "colorDataCatagorical-3": "var(--phx-web-color-data-catagorical-3)",
  "colorDataCatagorical-4": "var(--phx-web-color-data-catagorical-4)",
  "colorDataCatagorical-5": "var(--phx-web-color-data-catagorical-5)",
  "colorDataCatagorical-6": "var(--phx-web-color-data-catagorical-6)",
  "colorDataCatagorical-7": "var(--phx-web-color-data-catagorical-7)",
  "colorDataCatagorical-8": "var(--phx-web-color-data-catagorical-8)",
  "colorDataCatagorical-9": "var(--phx-web-color-data-catagorical-9)",
  "colorDataCatagorical-10": "var(--phx-web-color-data-catagorical-10)",
  "colorDataCatagorical-11": "var(--phx-web-color-data-catagorical-11)",
  "colorDataCatagorical-12": "var(--phx-web-color-data-catagorical-12)",
  "colorDataDivBlueOrange-5-1": "var(--phx-web-color-data-div-blue-orange-5-1)",
  "colorDataDivBlueOrange-5-2": "var(--phx-web-color-data-div-blue-orange-5-2)",
  "colorDataDivBlueOrange-5-3": "var(--phx-web-color-data-div-blue-orange-5-3)",
  "colorDataDivBlueOrange-5-4": "var(--phx-web-color-data-div-blue-orange-5-4)",
  "colorDataDivBlueOrange-5-5": "var(--phx-web-color-data-div-blue-orange-5-5)",
  "colorDataDivBlueOrange-6-1": "var(--phx-web-color-data-div-blue-orange-6-1)",
  "colorDataDivBlueOrange-6-2": "var(--phx-web-color-data-div-blue-orange-6-2)",
  "colorDataDivBlueOrange-6-3": "var(--phx-web-color-data-div-blue-orange-6-3)",
  "colorDataDivBlueOrange-6-4": "var(--phx-web-color-data-div-blue-orange-6-4)",
  "colorDataDivBlueOrange-6-5": "var(--phx-web-color-data-div-blue-orange-6-5)",
  "colorDataDivBlueOrange-6-6": "var(--phx-web-color-data-div-blue-orange-6-6)",
  "colorDataDivBlueOrange-7-1": "var(--phx-web-color-data-div-blue-orange-7-1)",
  "colorDataDivBlueOrange-7-2": "var(--phx-web-color-data-div-blue-orange-7-2)",
  "colorDataDivBlueOrange-7-3": "var(--phx-web-color-data-div-blue-orange-7-3)",
  "colorDataDivBlueOrange-7-4": "var(--phx-web-color-data-div-blue-orange-7-4)",
  "colorDataDivBlueOrange-7-5": "var(--phx-web-color-data-div-blue-orange-7-5)",
  "colorDataDivBlueOrange-7-6": "var(--phx-web-color-data-div-blue-orange-7-6)",
  "colorDataDivBlueOrange-7-7": "var(--phx-web-color-data-div-blue-orange-7-7)",
  "colorDataDivBlueRed-5-1": "var(--phx-web-color-data-div-blue-red-5-1)",
  "colorDataDivBlueRed-5-2": "var(--phx-web-color-data-div-blue-red-5-2)",
  "colorDataDivBlueRed-5-3": "var(--phx-web-color-data-div-blue-red-5-3)",
  "colorDataDivBlueRed-5-4": "var(--phx-web-color-data-div-blue-red-5-4)",
  "colorDataDivBlueRed-5-5": "var(--phx-web-color-data-div-blue-red-5-5)",
  "colorDataDivBlueRed-6-1": "var(--phx-web-color-data-div-blue-red-6-1)",
  "colorDataDivBlueRed-6-2": "var(--phx-web-color-data-div-blue-red-6-2)",
  "colorDataDivBlueRed-6-3": "var(--phx-web-color-data-div-blue-red-6-3)",
  "colorDataDivBlueRed-6-4": "var(--phx-web-color-data-div-blue-red-6-4)",
  "colorDataDivBlueRed-6-5": "var(--phx-web-color-data-div-blue-red-6-5)",
  "colorDataDivBlueRed-6-6": "var(--phx-web-color-data-div-blue-red-6-6)",
  "colorDataDivBlueRed-7-1": "var(--phx-web-color-data-div-blue-red-7-1)",
  "colorDataDivBlueRed-7-2": "var(--phx-web-color-data-div-blue-red-7-2)",
  "colorDataDivBlueRed-7-3": "var(--phx-web-color-data-div-blue-red-7-3)",
  "colorDataDivBlueRed-7-4": "var(--phx-web-color-data-div-blue-red-7-4)",
  "colorDataDivBlueRed-7-5": "var(--phx-web-color-data-div-blue-red-7-5)",
  "colorDataDivBlueRed-7-6": "var(--phx-web-color-data-div-blue-red-7-6)",
  "colorDataDivBlueRed-7-7": "var(--phx-web-color-data-div-blue-red-7-7)",
  "colorDataDivPurpleTeal-5-1": "var(--phx-web-color-data-div-purple-teal-5-1)",
  "colorDataDivPurpleTeal-5-2": "var(--phx-web-color-data-div-purple-teal-5-2)",
  "colorDataDivPurpleTeal-5-3": "var(--phx-web-color-data-div-purple-teal-5-3)",
  "colorDataDivPurpleTeal-5-4": "var(--phx-web-color-data-div-purple-teal-5-4)",
  "colorDataDivPurpleTeal-5-5": "var(--phx-web-color-data-div-purple-teal-5-5)",
  "colorDataDivPurpleTeal-6-1": "var(--phx-web-color-data-div-purple-teal-6-1)",
  "colorDataDivPurpleTeal-6-2": "var(--phx-web-color-data-div-purple-teal-6-2)",
  "colorDataDivPurpleTeal-6-3": "var(--phx-web-color-data-div-purple-teal-6-3)",
  "colorDataDivPurpleTeal-6-4": "var(--phx-web-color-data-div-purple-teal-6-4)",
  "colorDataDivPurpleTeal-6-5": "var(--phx-web-color-data-div-purple-teal-6-5)",
  "colorDataDivPurpleTeal-6-6": "var(--phx-web-color-data-div-purple-teal-6-6)",
  "colorDataDivPurpleTeal-7-1": "var(--phx-web-color-data-div-purple-teal-7-1)",
  "colorDataDivPurpleTeal-7-2": "var(--phx-web-color-data-div-purple-teal-7-2)",
  "colorDataDivPurpleTeal-7-3": "var(--phx-web-color-data-div-purple-teal-7-3)",
  "colorDataDivPurpleTeal-7-4": "var(--phx-web-color-data-div-purple-teal-7-4)",
  "colorDataDivPurpleTeal-7-5": "var(--phx-web-color-data-div-purple-teal-7-5)",
  "colorDataDivPurpleTeal-7-6": "var(--phx-web-color-data-div-purple-teal-7-6)",
  "colorDataDivPurpleTeal-7-7": "var(--phx-web-color-data-div-purple-teal-7-7)",
  "colorDataDivPurpleYellow-5-1": "var(--phx-web-color-data-div-purple-yellow-5-1)",
  "colorDataDivPurpleYellow-5-2": "var(--phx-web-color-data-div-purple-yellow-5-2)",
  "colorDataDivPurpleYellow-5-3": "var(--phx-web-color-data-div-purple-yellow-5-3)",
  "colorDataDivPurpleYellow-5-4": "var(--phx-web-color-data-div-purple-yellow-5-4)",
  "colorDataDivPurpleYellow-5-5": "var(--phx-web-color-data-div-purple-yellow-5-5)",
  "colorDataDivPurpleYellow-6-1": "var(--phx-web-color-data-div-purple-yellow-6-1)",
  "colorDataDivPurpleYellow-6-2": "var(--phx-web-color-data-div-purple-yellow-6-2)",
  "colorDataDivPurpleYellow-6-3": "var(--phx-web-color-data-div-purple-yellow-6-3)",
  "colorDataDivPurpleYellow-6-5": "var(--phx-web-color-data-div-purple-yellow-6-5)",
  "colorDataDivPurpleYellow-6-6": "var(--phx-web-color-data-div-purple-yellow-6-6)",
  "colorDataDivPurpleYellow-7-1": "var(--phx-web-color-data-div-purple-yellow-7-1)",
  "colorDataDivPurpleYellow-7-2": "var(--phx-web-color-data-div-purple-yellow-7-2)",
  "colorDataDivPurpleYellow-7-3": "var(--phx-web-color-data-div-purple-yellow-7-3)",
  "colorDataDivPurpleYellow-7-5": "var(--phx-web-color-data-div-purple-yellow-7-5)",
  "colorDataDivPurpleYellow-7-6": "var(--phx-web-color-data-div-purple-yellow-7-6)",
  "colorDataDivPurpleYellow-7-7": "var(--phx-web-color-data-div-purple-yellow-7-7)",
  "colorDataScoreSafetyFair": "var(--phx-web-color-data-score-safety-fair)",
  "colorDataScoreSafetyGood": "var(--phx-web-color-data-score-safety-good)",
  "colorDataScoreSafetyExcellent": "var(--phx-web-color-data-score-safety-excellent)",
  "colorDataScoreFuelFair": "var(--phx-web-color-data-score-fuel-fair)",
  "colorDataScoreFuelGood": "var(--phx-web-color-data-score-fuel-good)",
  "colorDataScoreFuelExcellent": "var(--phx-web-color-data-score-fuel-excellent)",
  "colorDataSeqBlue-2-1": "var(--phx-web-color-data-seq-blue-2-1)",
  "colorDataSeqBlue-2-2": "var(--phx-web-color-data-seq-blue-2-2)",
  "colorDataSeqBlue-3-1": "var(--phx-web-color-data-seq-blue-3-1)",
  "colorDataSeqBlue-3-2": "var(--phx-web-color-data-seq-blue-3-2)",
  "colorDataSeqBlue-3-3": "var(--phx-web-color-data-seq-blue-3-3)",
  "colorDataSeqBlue-4-1": "var(--phx-web-color-data-seq-blue-4-1)",
  "colorDataSeqBlue-4-2": "var(--phx-web-color-data-seq-blue-4-2)",
  "colorDataSeqBlue-4-3": "var(--phx-web-color-data-seq-blue-4-3)",
  "colorDataSeqBlue-4-4": "var(--phx-web-color-data-seq-blue-4-4)",
  "colorDataSeqBlue-5-1": "var(--phx-web-color-data-seq-blue-5-1)",
  "colorDataSeqBlue-5-2": "var(--phx-web-color-data-seq-blue-5-2)",
  "colorDataSeqBlue-5-3": "var(--phx-web-color-data-seq-blue-5-3)",
  "colorDataSeqBlue-5-4": "var(--phx-web-color-data-seq-blue-5-4)",
  "colorDataSeqBlue-5-5": "var(--phx-web-color-data-seq-blue-5-5)",
  "colorDataSeqBlue-6-1": "var(--phx-web-color-data-seq-blue-6-1)",
  "colorDataSeqBlue-6-2": "var(--phx-web-color-data-seq-blue-6-2)",
  "colorDataSeqBlue-6-3": "var(--phx-web-color-data-seq-blue-6-3)",
  "colorDataSeqBlue-6-4": "var(--phx-web-color-data-seq-blue-6-4)",
  "colorDataSeqBlue-6-5": "var(--phx-web-color-data-seq-blue-6-5)",
  "colorDataSeqBlue-6-6": "var(--phx-web-color-data-seq-blue-6-6)",
  "colorDataSeqBlue-7-1": "var(--phx-web-color-data-seq-blue-7-1)",
  "colorDataSeqBlue-7-2": "var(--phx-web-color-data-seq-blue-7-2)",
  "colorDataSeqBlue-7-3": "var(--phx-web-color-data-seq-blue-7-3)",
  "colorDataSeqBlue-7-4": "var(--phx-web-color-data-seq-blue-7-4)",
  "colorDataSeqBlue-7-5": "var(--phx-web-color-data-seq-blue-7-5)",
  "colorDataSeqBlue-7-6": "var(--phx-web-color-data-seq-blue-7-6)",
  "colorDataSeqBlue-7-7": "var(--phx-web-color-data-seq-blue-7-7)",
  "colorDataSeqPurple-2-1": "var(--phx-web-color-data-seq-purple-2-1)",
  "colorDataSeqPurple-2-2": "var(--phx-web-color-data-seq-purple-2-2)",
  "colorDataSeqPurple-3-1": "var(--phx-web-color-data-seq-purple-3-1)",
  "colorDataSeqPurple-3-2": "var(--phx-web-color-data-seq-purple-3-2)",
  "colorDataSeqPurple-3-3": "var(--phx-web-color-data-seq-purple-3-3)",
  "colorDataSeqPurple-4-1": "var(--phx-web-color-data-seq-purple-4-1)",
  "colorDataSeqPurple-4-2": "var(--phx-web-color-data-seq-purple-4-2)",
  "colorDataSeqPurple-4-3": "var(--phx-web-color-data-seq-purple-4-3)",
  "colorDataSeqPurple-4-4": "var(--phx-web-color-data-seq-purple-4-4)",
  "colorDataSeqPurple-5-1": "var(--phx-web-color-data-seq-purple-5-1)",
  "colorDataSeqPurple-5-2": "var(--phx-web-color-data-seq-purple-5-2)",
  "colorDataSeqPurple-5-3": "var(--phx-web-color-data-seq-purple-5-3)",
  "colorDataSeqPurple-5-4": "var(--phx-web-color-data-seq-purple-5-4)",
  "colorDataSeqPurple-5-5": "var(--phx-web-color-data-seq-purple-5-5)",
  "colorDataSeqPurple-6-1": "var(--phx-web-color-data-seq-purple-6-1)",
  "colorDataSeqPurple-6-2": "var(--phx-web-color-data-seq-purple-6-2)",
  "colorDataSeqPurple-6-3": "var(--phx-web-color-data-seq-purple-6-3)",
  "colorDataSeqPurple-6-4": "var(--phx-web-color-data-seq-purple-6-4)",
  "colorDataSeqPurple-6-5": "var(--phx-web-color-data-seq-purple-6-5)",
  "colorDataSeqPurple-6-6": "var(--phx-web-color-data-seq-purple-6-6)",
  "colorDataSeqPurple-7-1": "var(--phx-web-color-data-seq-purple-7-1)",
  "colorDataSeqPurple-7-2": "var(--phx-web-color-data-seq-purple-7-2)",
  "colorDataSeqPurple-7-3": "var(--phx-web-color-data-seq-purple-7-3)",
  "colorDataSeqPurple-7-4": "var(--phx-web-color-data-seq-purple-7-4)",
  "colorDataSeqPurple-7-5": "var(--phx-web-color-data-seq-purple-7-5)",
  "colorDataSeqPurple-7-6": "var(--phx-web-color-data-seq-purple-7-6)",
  "colorDataSeqPurple-7-7": "var(--phx-web-color-data-seq-purple-7-7)",
  "colorDataSeqTeal-2-1": "var(--phx-web-color-data-seq-teal-2-1)",
  "colorDataSeqTeal-2-2": "var(--phx-web-color-data-seq-teal-2-2)",
  "colorDataSeqTeal-3-1": "var(--phx-web-color-data-seq-teal-3-1)",
  "colorDataSeqTeal-3-2": "var(--phx-web-color-data-seq-teal-3-2)",
  "colorDataSeqTeal-3-3": "var(--phx-web-color-data-seq-teal-3-3)",
  "colorDataSeqTeal-4-1": "var(--phx-web-color-data-seq-teal-4-1)",
  "colorDataSeqTeal-4-2": "var(--phx-web-color-data-seq-teal-4-2)",
  "colorDataSeqTeal-4-3": "var(--phx-web-color-data-seq-teal-4-3)",
  "colorDataSeqTeal-4-4": "var(--phx-web-color-data-seq-teal-4-4)",
  "colorDataSeqTeal-5-1": "var(--phx-web-color-data-seq-teal-5-1)",
  "colorDataSeqTeal-5-2": "var(--phx-web-color-data-seq-teal-5-2)",
  "colorDataSeqTeal-5-3": "var(--phx-web-color-data-seq-teal-5-3)",
  "colorDataSeqTeal-5-4": "var(--phx-web-color-data-seq-teal-5-4)",
  "colorDataSeqTeal-5-5": "var(--phx-web-color-data-seq-teal-5-5)",
  "colorDataSeqTeal-6-1": "var(--phx-web-color-data-seq-teal-6-1)",
  "colorDataSeqTeal-6-2": "var(--phx-web-color-data-seq-teal-6-2)",
  "colorDataSeqTeal-6-3": "var(--phx-web-color-data-seq-teal-6-3)",
  "colorDataSeqTeal-6-4": "var(--phx-web-color-data-seq-teal-6-4)",
  "colorDataSeqTeal-6-5": "var(--phx-web-color-data-seq-teal-6-5)",
  "colorDataSeqTeal-6-6": "var(--phx-web-color-data-seq-teal-6-6)",
  "colorDataSeqTeal-7-1": "var(--phx-web-color-data-seq-teal-7-1)",
  "colorDataSeqTeal-7-2": "var(--phx-web-color-data-seq-teal-7-2)",
  "colorDataSeqTeal-7-3": "var(--phx-web-color-data-seq-teal-7-3)",
  "colorDataSeqTeal-7-4": "var(--phx-web-color-data-seq-teal-7-4)",
  "colorDataSeqTeal-7-5": "var(--phx-web-color-data-seq-teal-7-5)",
  "colorDataSeqTeal-7-6": "var(--phx-web-color-data-seq-teal-7-6)",
  "colorDataSeqTeal-7-7": "var(--phx-web-color-data-seq-teal-7-7)",
  "colorDataIntentBoldBlue": "var(--phx-web-color-data-intent-bold-blue)",
  "colorDataIntentBoldRed": "var(--phx-web-color-data-intent-bold-red)",
  "colorDataIntentBoldGreen": "var(--phx-web-color-data-intent-bold-green)",
  "colorDataIntentBoldYellow": "var(--phx-web-color-data-intent-bold-yellow)",
  "colorDataIntentBoldOrange": "var(--phx-web-color-data-intent-bold-orange)",
  "colorDataIntentBoldMagenta": "var(--phx-web-color-data-intent-bold-magenta)",
  "colorDataIntentBoldPurple": "var(--phx-web-color-data-intent-bold-purple)",
  "colorDataIntentMediumBlue": "var(--phx-web-color-data-intent-medium-blue)",
  "colorDataIntentMediumRed": "var(--phx-web-color-data-intent-medium-red)",
  "colorDataIntentMediumGreen": "var(--phx-web-color-data-intent-medium-green)",
  "colorDataIntentMediumYellow": "var(--phx-web-color-data-intent-medium-yellow)",
  "colorDataIntentMediumOrange": "var(--phx-web-color-data-intent-medium-orange)",
  "colorDataIntentMediumMagenta": "var(--phx-web-color-data-intent-medium-magenta)",
  "colorDataIntentMediumPurple": "var(--phx-web-color-data-intent-medium-purple)",
  "colorStroke": "var(--phx-web-color-stroke)",
  "colorStrokeStandard": "var(--phx-web-color-stroke-standard)",
  "colorStrokeEmphasis": "var(--phx-web-color-stroke-emphasis)",
  "colorStrokeMoreEmphasis": "var(--phx-web-color-stroke-more-emphasis)",
  "colorStrokeInactive": "var(--phx-web-color-stroke-inactive)",
  "colorStrokeActive": "var(--phx-web-color-stroke-active)",
  "colorStrokeAccent": "var(--phx-web-color-stroke-accent)",
  "colorStrokePositive": "var(--phx-web-color-stroke-positive)",
  "colorStrokeCaution": "var(--phx-web-color-stroke-caution)",
  "colorStrokeWarning": "var(--phx-web-color-stroke-warning)",
  "colorStrokeNegative": "var(--phx-web-color-stroke-negative)",
  "colorStrokeOnMedium": "var(--phx-web-color-stroke-on-medium)",
  "colorStrokeOnMediumStandard": "var(--phx-web-color-stroke-on-medium-standard)",
  "colorStrokeOnMediumEmphasis": "var(--phx-web-color-stroke-on-medium-emphasis)",
  "colorStrokeOnMediumMoreEmphasis": "var(--phx-web-color-stroke-on-medium-more-emphasis)",
  "colorStrokeOnMediumInactive": "var(--phx-web-color-stroke-on-medium-inactive)",
  "colorStrokeOnMediumActive": "var(--phx-web-color-stroke-on-medium-active)",
  "colorStrokeOnBold": "var(--phx-web-color-stroke-on-bold)",
  "colorStrokeOnBoldStandard": "var(--phx-web-color-stroke-on-bold-standard)",
  "colorStrokeOnBoldEmphasis": "var(--phx-web-color-stroke-on-bold-emphasis)",
  "colorStrokeOnBoldMoreEmphasis": "var(--phx-web-color-stroke-on-bold-more-emphasis)",
  "colorStrokeOnBoldInactive": "var(--phx-web-color-stroke-on-bold-inactive)",
  "colorStrokeOnBoldActive": "var(--phx-web-color-stroke-on-bold-active)",
  "colorStrokeOnSummary": "var(--phx-web-color-stroke-on-summary)",
  "colorStrokeOnSummaryStandard": "var(--phx-web-color-stroke-on-summary-standard)",
  "colorStrokeOnSummaryEmphasis": "var(--phx-web-color-stroke-on-summary-emphasis)",
  "colorStrokeOnSummaryMoreEmphasis": "var(--phx-web-color-stroke-on-summary-more-emphasis)",
  "colorStrokeOnSummaryInactive": "var(--phx-web-color-stroke-on-summary-inactive)",
  "colorStrokeOnSummaryActive": "var(--phx-web-color-stroke-on-summary-active)",
  "colorStrokeOnInverted": "var(--phx-web-color-stroke-on-inverted)",
  "colorStrokeOnInvertedStandard": "var(--phx-web-color-stroke-on-inverted-standard)",
  "colorStrokeOnInvertedEmphasis": "var(--phx-web-color-stroke-on-inverted-emphasis)",
  "colorStrokeOnInvertedMoreEmphasis": "var(--phx-web-color-stroke-on-inverted-more-emphasis)",
  "colorStrokeOnInvertedInactive": "var(--phx-web-color-stroke-on-inverted-inactive)",
  "colorStrokeOnInvertedActive": "var(--phx-web-color-stroke-on-inverted-active)",
  "colorStrokeOnOverlay": "var(--phx-web-color-stroke-on-overlay)",
  "colorStrokeOnOverlayStandard": "var(--phx-web-color-stroke-on-overlay-standard)",
  "colorStrokeOnOverlayEmphasis": "var(--phx-web-color-stroke-on-overlay-emphasis)",
  "colorStrokeOnOverlayMoreEmphasis": "var(--phx-web-color-stroke-on-overlay-more-emphasis)",
  "colorStrokeOnOverlayInactive": "var(--phx-web-color-stroke-on-overlay-inactive)",
  "colorStrokeOnOverlayActive": "var(--phx-web-color-stroke-on-overlay-active)",
  "colorStrokeOnAlwaysDark": "var(--phx-web-color-stroke-on-always-dark)",
  "colorStrokeOnAlwaysDarkStandard": "var(--phx-web-color-stroke-on-always-dark-standard)",
  "colorStrokeOnAlwaysDarkEmphasis": "var(--phx-web-color-stroke-on-always-dark-emphasis)",
  "colorStrokeOnAlwaysDarkMoreEmphasis": "var(--phx-web-color-stroke-on-always-dark-more-emphasis)",
  "colorStrokeOnAlwaysDarkInactive": "var(--phx-web-color-stroke-on-always-dark-inactive)",
  "colorStrokeOnAlwaysDarkActive": "var(--phx-web-color-stroke-on-always-dark-active)"
};